import React, { FunctionComponent } from 'react';
import { Models, Api } from '@core/types';
import { Close } from '@components/icons';
import { connect } from 'react-redux';
import { projectActionCreators } from '@redux/projects';
import { usePassportContext } from '@tti/passport';
import { Routes } from '@components/routing/Routes';
import { push } from 'connected-react-router';
import { uniqueId } from 'lodash';
import classNames from 'classnames';

interface IProps {
  project: Models.Project;
  deleteProject: (params: Api.IDeleteProjectRequest) => void;
  redirect: (url: string) => void;
  onSelect: (projectGUID: string, isSelected: boolean) => void;
  isSelected?: boolean;
}

const ProjectRow: FunctionComponent<IProps> = ({ project, deleteProject, redirect, onSelect, isSelected }) => {
  const { passportContext } = usePassportContext();

  const handleDelete = (e: React.MouseEvent) => {
    e.stopPropagation();

    deleteProject({
      bearerToken: passportContext.bearerToken || '',
      projectGUID: project.projectGUID,
    });
  };

  const handleClick = () => {
    const url = `${Routes.project.slug}${project.projectGUID}`;

    redirect(url);
  };

  const handleCheckboxChange = (e: React.ChangeEvent<HTMLInputElement>) => {
    e.stopPropagation();
    if (onSelect) {
      onSelect(project.projectGUID, e.target.checked);
    }
  };

  const fieldID = uniqueId('projectRow_');

  const labelClassNames = classNames({
    'project-item--label': true,
    'hide-checkbox': onSelect === undefined,
  });

  const rowClassNames = classNames({
    'project-item': true,
    'project-item--link': onSelect === undefined,
  });

  const isSelectionMode = onSelect !== undefined;

  return (
    <div className={rowClassNames} onClick={handleClick}>
      <div className="project-item__container">
        {isSelectionMode && (
          <>
            <input
              id={fieldID}
              type="checkbox"
              checked={isSelected || false}
              onChange={handleCheckboxChange}
              className="project-item--input"
              onClick={(e) => e.stopPropagation()}
            />
            <label
              htmlFor={isSelectionMode ? fieldID : undefined}
              className={labelClassNames}
              onClick={isSelectionMode ? (e) => e.stopPropagation() : undefined}
            />
          </>
        )}
        <div className="project-item__content">
          <div className="project-item__title">{project.projectName}</div>
          <div className="project-item__date">Last Edited {project.lastModifiedISO}</div>
        </div>
        <div className="project-item__controls">
          <div className="project-item__button" onClick={handleDelete}>
            <Close />
            <div className="project-item__remove">Remove</div>
          </div>
        </div>
      </div>
    </div>
  );
};

const mapDispatchToProps = {
  deleteProject: (params: Api.IDeleteProjectRequest) => projectActionCreators.deleteProject(params),
  redirect: (url: string) => push(url),
};

export default connect(null, mapDispatchToProps)(ProjectRow);
